import { memo } from 'react'

import FacilitationHeader, { TEST_ID } from './FacilitationHeader'

const FacilitationHeaderComponent = memo(FacilitationHeader)

export { TEST_ID }

export default FacilitationHeaderComponent
